import { render, staticRenderFns } from "./EditTranslationModal.vue?vue&type=template&id=b7da749a&lang=pug&"
import script from "./EditTranslationModal.vue?vue&type=script&lang=js&"
export * from "./EditTranslationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports